import { render, staticRenderFns } from "./componentList.vue?vue&type=template&id=1bc88446&"
import script from "./componentList.vue?vue&type=script&lang=js&"
export * from "./componentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports